<template>
  <div class="mai-wrapper">
    <app-sections></app-sections>
  </div>
</template>

<script>
import Sections from "./Sections.vue";
export default {
  components: {
    "app-sections": Sections
  }
};

$("body").on(
  "click",
  "#main-navbar .nav-item, .mai-user-nav .dropdown-menu .dropdown-item",
  function(e) {
    var $this = $(e.target);
    var $targetItem;

    $("#main-navbar").collapse("hide");
    $("#main-navbar")
      .find(".nav-item")
      .removeClass("open");

    if ($this.hasClass("dropdown-item")) {
      $targetItem = $this;
    } else {
      $targetItem = $this.closest(".nav-item");
      $targetItem.addClass("open");
    }

    $(".sections>.section").removeClass("open");
    $("#" + $targetItem.attr("section") + "-section").addClass("open");
    adjustTable();
  }
);

function adjustTable() {
  $.each($("table.dataTable[id]:visible"), function(index, element) {
    $(element)
      .dataTable()
      ._fnAdjustColumnSizing();
  });
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue